<template>
	<div>
		<CRow
			:class="['mb-3', { hide: hideCheckAll }]"
		>
			<CCol>
				<CInputCheckbox
					ref="checkAllRef"
					:checked="state.isCheckedAll"
					:label="$t('label.select_all')"
					add-input-classes="input-checkbox"
					add-label-classes="input-label font-weight-bold"
					custom
					@update:checked="handleCheckedAll"
				/>
			</CCol>
		</CRow>
		<CRow>
			<CCol class="container-checkbox">
				{{ state.items }}
				<ul class="list-group">
					<li
						v-for="({ label }, index) in state.items"
						:key="index"
						class="list-group-item p-0 border-none mb-1"
					>
						<CInputCheckbox
							:checked="state.items[index].value"
							:label="label"
							:disabled="state.isCheckedAll"
							custom
							add-input-classes="input-checkbox"
							add-label-classes="input-label"
							@update:checked="handleChecked($event, index)"
						/>
					</li>
				</ul>
			</CCol>
		</CRow>
	</div>
</template>

<script>
import { ref } from '@vue/composition-api';
import useMultipleSelect from '../use/mutipleSelect';

export default {
	components: {
		// DynamicScroller,
		// DynamicScrollerItem,
	},
	props: {
		items: {
			type: Array,
			default: () => [],
		},
		checkedIds: {
			type: Array,
			default: () => [],
		},
		checkAll: {
			type: Boolean,
			default: false,
		},
		hideCheckAll: {
			type: Boolean,
			default: false,
		},
		disabledSelectAll: {
			type: Boolean,
			default: false,
		},
	},

	setup(props, context) {
		const checkAllRef = ref(null);

		const options = {
			doms: {
				checkAllRef,
			},
		};

		const { state, handleChecked, handleCheckedAll } = useMultipleSelect(props, context, options);

		return {
			state,
			handleChecked,
			handleCheckedAll,
			checkAllRef,
		};
	},
};
</script>

<style lang="scss" scoped>
.container-checkbox {
	max-height: 350px;
	overflow-y: auto;
	overflow-x: hidden;
}

.hide {
	visibility: hidden;
	height: 0;
	overflow: auto;
	margin: 0 !important;
}
</style>